import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

// The "Färger" toggle cycles through three looks for the areas (kartvy toolbar, listvy map button):
//   colours: filled in the metric colour, thin black lines
//   lines:   no fill, each area's border in its metric colour   (checkedState.hideMap)
//   off:     no area overlay at all — the plain base map        (hideMap + checkedState.hideLines + hideOverlay)
// In colours/lines a hovered or opened area still gets its outline; in off nothing area-related shows (no hover,
// no dimming, no selection line, no grey areas, no funnels, no legend). Listing markers stay. A fourth look, no
// fill and no lines but the areas still there ("Ingen"), was dropped on 2026-11-01 (the owner: Av is enough); a
// state with no fill and no lines is read as off.

export const getColourMode = (checkedState) => {
    if (checkedState?.hideOverlay || (checkedState?.hideMap && checkedState?.hideLines)) return 'off';
    if (!checkedState?.hideMap) return 'colours';
    return 'lines';
};

// The checkedState after one press of the toggle.
export const nextColourModeState = (checkedState) => {
    const mode = getColourMode(checkedState);
    if (mode === 'colours') return { ...checkedState, hideMap: true, hideLines: false, hideOverlay: false };
    if (mode === 'lines') return { ...checkedState, hideMap: true, hideLines: true, hideOverlay: true };
    return { ...checkedState, hideMap: false, hideLines: false, hideOverlay: false };
};

// What a press does next, for the button's label.
export const nextColourModeLabel = (mode, swedish) => ({
    colours: swedish ? 'Visa bara linjer' : 'Show lines only',
    lines: swedish ? 'Dölj områdeslagret helt' : 'Hide the area overlay',
    off: swedish ? 'Visa färger' : 'Show colours',
}[mode]);

// The current look, for the toolbar's state line: [sv, en].
export const COLOUR_MODE_NAMES = {
    colours: ['Fyllda', 'Filled'],
    lines: ['Linjer', 'Lines'],
    off: ['Av', 'Off'],
};

const LAYER_COUNT = { colours: 3, lines: 2, off: 1 };

// A stack of 3, 2 or 1 layers for the modes; 'off' adds a diagonal slash that crosses the stack out. An MUI
// SvgIcon, so it sizes like the other icons.
export const ColourModeIcon = ({ mode, fontSize }) => {
    const count = LAYER_COUNT[mode] || 3;
    // The top layer moves down as layers are removed, so the stack stays centred.
    const shift = (3 - count) * 2.5;
    return (
        <SvgIcon fontSize={fontSize} aria-hidden="true" focusable="false">
            <g transform={`translate(0 ${shift})`}>
                <path d="M12 2.5 21.5 7.5 12 12.5 2.5 7.5z" />
                {count >= 2 && <path d="M4.3 11.1 2.5 12.1 12 17.1l9.5-5-1.8-1L12 15.1z" />}
                {count >= 3 && <path d="M4.3 15.7 2.5 16.7 12 21.7l9.5-5-1.8-1L12 19.7z" />}
            </g>
            {mode === 'off' && (
                // A casing (background colour via the host's circle, drawn first and wider) then the slash,
                // so it reads as a cut even over the white layer.
                <>
                    <path d="M4 3 L21 20" fill="none" stroke="var(--color-mode-slash-casing, #3b947e)" strokeWidth="4.6" strokeLinecap="round" />
                    <path d="M4 3 L21 20" fill="none" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" />
                </>
            )}
        </SvgIcon>
    );
};
